export default __webpack_public_path__ + "static/Edita_Prima_photo_bg_culture_page-77070efa083225496ed106a2b854c101.jpg";